import { dropdownHandler } from './dropdown';
import { inputHandler } from './input';
import { clearQuery } from './utils';

export const filterHandler = (parentSelector, onFilter) => {
  const filter = parentSelector.querySelector('[data-filter-fields]');
  const clearButton = parentSelector.querySelector('[data-clear-button]');

  if (!filter || !clearButton) return;
  const dropdowns = filter.querySelectorAll('[data-dropdown]');
  const search = filter.querySelector('[data-input-search]');
  const searchWrapper = search.closest('[data-input-field]');

  const dropdownCleanupFn = [];
  const body = {};

    const clearInputValue = inputHandler(searchWrapper, (value) => {
    const trimmedValue = value.trimEnd();

      body[search?.id] = trimmedValue;
      if (Object.keys(body).length === dropdowns?.length + 1) {
      onFilter(body);
    }
  });

  Array.from(dropdowns)?.forEach((item) => {
    const dropdownCleanup = dropdownHandler(item, (value) => {
      body[item?.id] = value;
      if (Object.keys(body).length === 3) onFilter(body);
    });
    dropdownCleanupFn.push(dropdownCleanup);
  }
  );

  const resetValues = () => {
    Object.keys(body).forEach((k) => body[k] = '');

    dropdownCleanupFn?.forEach((fn) => fn());
    clearInputValue({ cleanUpCbFn: null });
    clearQuery();
    onFilter(body);
  };

  clearButton?.addEventListener('click', () => {
    resetValues();
  }
  );

  clearButton?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === '') {
      resetValues();
    }
  });

};
